import React from "react";
import classnames from "classnames";
import {
    CheckboxIcon,
    PlusIcon,
    VerticalDotsIcon,
} from "@aureskonnect/react-ui";
import { useSnapshot } from "valtio";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { uuid } from "uuidv4";

import { store as useStore } from "../../../../components/VerticalLayout/store";
import {
    setFranchiseDataIsUpdated,
    setIsHistoryModalOpened,
    setIsInlineErrorCleared,
    setShopDataIsUpdated,
    store,
    setActions,
    setIsActionsClicked,
    setIsEdited,
    setIsLoading,
    setKey,
} from "../store";

import ErrorToast from "../../../../components/Common/ErrorTost";
import { ConfirmationArchive } from "../ConfirmationArchive";

import { CustomMainColorIconButton } from "@components/Common/CustomMainColorIconButton";
import { CustomMainColorButtonWithIcon } from "@components/Common/CustomMainColorButtonWithIcon";
import { CustomSideFilterType } from "../Types";
import { CreateDataThirdParty } from "../helper";

export function CustomSideFilter({ data }: CustomSideFilterType) {
    const { t } = useTranslation();
    const { oneShop, userID, franchiseID, operatorID } = useSnapshot(useStore);
    const {
        numberArchived,
        numberActive,
        isHistoryModalOpened,
        shopsThirdPartyData,
        isInlineErrorCleared,
        listFranchiseArchived,
        isEdited,
        isActionsClicked,
        modify,
        isLoading,
    } = useSnapshot(store);
    const uuidUser = localStorage.getItem("uuidUser");
    let dataArchive: any[] = [];
    if (!oneShop) {
        dataArchive = ArchivedThirdParty();
    } else {
        dataArchive = ArchivedThirdPartyFranchise();
    }
    const [isActive, setIsActive] = React.useState<boolean>(false);
    const [
        isArchivedValidationModalOpened,
        setIsArchivedValidationModalOpened,
    ] = React.useState<boolean>(false);
    const [isValidateClicked, setIsValidateClicked] = React.useState<boolean>(
        false
    );
    function ArchivedThirdParty() {
        let idsAssociated: any[] = [];
        if (shopsThirdPartyData !== undefined) {
            shopsThirdPartyData.forEach((element: any) => {
                element.subRows.forEach((el: any) => {
                    idsAssociated.push(el.Id);
                });
            });
        }
        idsAssociated = [...new Set(idsAssociated)];
        return idsAssociated;
    }
    function ArchivedThirdPartyFranchise() {
        let idsAssociated: any[] = [];
        if (listFranchiseArchived !== undefined) {
            listFranchiseArchived.forEach((element: any) => {
                idsAssociated.push(element.Id);
            });
        }
        idsAssociated = [...new Set(idsAssociated)];
        return idsAssociated;
    }
    function thirdPartyExistInShops() {
        let isIdExist;
        let idsAssociated: any = [];

        shopsThirdPartyData.forEach((el: any) => {
            el.subRows.forEach((element: any) => {
                idsAssociated.push(element.Id);
            });
        });
        data.selectedRows.forEach((el: any) => {
            if (idsAssociated.includes(el.Id)) {
                isIdExist = true;
            }
        });

        if (isIdExist === true && !oneShop) {
            ErrorToast(
                `${t(
                    "Please note that you cannot archive an item assigned to stores."
                )!}`
            );
        } else {
            setIsArchivedValidationModalOpened(true);
        }
    }

    async function handleArchiveThirdParty(value: boolean) {
        setIsLoading(true);
        toast.dismiss();
        data.setLimit(1);
        let localData: any = [];
        const apiUrl = `${process.env.REACT_APP_API_V2_URL}/settings/general/thirdParty`;
        if (
            (isValidateClicked && data.selectedRows.length !== 0) ||
            (data.isArchivedThirdPartyClicked && data.selectedRows.length !== 0)
        ) {
            data.selectedRows.forEach(async (el: any) => {
                let thirdData = CreateDataThirdParty(
                    false,
                    false,
                    el.shopId,
                    el.shopId === "0" && value === false ? true : false,
                    false,
                    userID,
                    franchiseID,
                    operatorID,
                    uuidUser,
                    el.Id,
                    el[t("Third party")],
                    el.ip,
                    el.portApi,
                    el.salesId,
                    el.menusId,
                    el.baseUrl,
                    el[t("Remark")],
                    value,
                    el.apiKey,
                    el.organization,
                    el.employee
                );

                localData.push(thirdData);
            });
            try {
                if (localData.length > 0) {
                    await fetch(apiUrl, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify(localData),
                    })
                        .then((response) => response.json())
                        .then((result) => {
                            if (result.error) {
                                throw Error("error");
                            }
                            setIsLoading(false);
                            setKey(uuid());
                            toast.success(
                                !value
                                    ? `${t(
                                          "The third party has been successfully unarchived."
                                      )!}`
                                    : `${t(
                                          "The third party has been successfully archived."
                                      )!}`,
                                {
                                    position: toast.POSITION.TOP_CENTER,
                                    autoClose: 2000,
                                    theme: "colored",
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    icon: (
                                        <CheckboxIcon
                                            height={25}
                                            width={25}
                                            fill="white"
                                        />
                                    ),
                                }
                            );
                        });
                }
            } catch (e) {
                toast.error(`${t("There's an error")!}`, {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 2000,
                    theme: "colored",
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
                setShopDataIsUpdated(true);
                setFranchiseDataIsUpdated(true);
                setIsLoading(false);
            }
        }
        setIsValidateClicked(!isValidateClicked);
    }

    function thirdPartyExistInShopsActivated() {
        let isIdExist;
        let idsAssociated: any = [];
        shopsThirdPartyData.forEach((el: any) => {
            el.subRows.forEach((element: any) => {
                idsAssociated.push(element.Id);
            });
        });
        data.selectedRows.forEach((el: any) => {
            if (idsAssociated.includes(el.Id)) {
                isIdExist = true;
            }
        });
        if (isIdExist === true) {
            data.setIsModalConfirmationOpened(!data.isModalConfirmationOpened);
        } else {
            !data.isArchivedThirdPartyClicked
                ? setIsArchivedValidationModalOpened(true)
                : handleArchiveThirdParty(false);
        }
    }

    React.useEffect(() => {
        if (isValidateClicked) {
            handleArchiveThirdParty(isActive);
        }
        // eslint-disable-next-line
    }, [isValidateClicked, isActive]);

    return (
        <div className="d-flex justify-content-start align-items-center ml-2">
            {modify === true ? (
                <>
                    {data.isAddThirdPartyClicked !== true ? (
                        <span
                            onClick={() => {
                                data.setIsAddThirdPartyClicked(
                                    !data.isAddThirdPartyClicked
                                );
                                data.setLocalFilterActive(false);
                                data.setThirdParty({});
                            }}
                            className={`${classnames(
                                "w-100 ml-2 cmn_btn_openForm",
                                {
                                    "not-allowed-icon__clz":
                                        data.isArchivedThirdPartyClicked ||
                                        isLoading,
                                }
                            )}`}
                        >
                            <CustomMainColorButtonWithIcon
                                icon="PlusIcon"
                                iconPosition="left"
                                rounded
                                variant="primary"
                                onClick={() => {
                                    setIsInlineErrorCleared(
                                        !isInlineErrorCleared
                                    );
                                }}
                            >
                                {t("Add a third party")}
                            </CustomMainColorButtonWithIcon>
                        </span>
                    ) : (
                        <CustomMainColorIconButton
                            icon="PlusIcon"
                            className="sdv_btn_FRreset "
                            rounded
                            disabled={
                                data.thirdParty.Id !== undefined ? true : false
                            }
                            onClick={() => {
                                if (isEdited === true) {
                                    data.setIsInInitializationModalOpened(true);
                                } else {
                                    setIsInlineErrorCleared(true);
                                }
                            }}
                        >
                            <PlusIcon height={20} width={20} fill="white" />
                        </CustomMainColorIconButton>
                    )}
                </>
            ) : null}

            <VerticalDotsIcon
                className="cmn_drp_FRmenu"
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                style={{ cursor: "pointer" }}
                height={25}
                width={25}
                fill="black"
            />
            <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                <div
                    style={{ cursor: "pointer" }}
                    className={classnames(
                        "dropdown-item pl-1 cmn_btn_FRlistActivated"
                    )}
                    onClick={() => {
                        data.setIsArchivedThirdPartyClicked(false);
                    }}
                >
                    {t("Enabled third parties")} ({numberActive})
                </div>
                <div
                    style={{ cursor: "pointer" }}
                    className={classnames(
                        "dropdown-item pl-1 cmn_btn_FRlistArchived "
                    )}
                    onClick={() => {
                        if (isEdited === true) {
                            setIsActionsClicked(!isActionsClicked);
                            setActions(() => {
                                setIsEdited(false);
                                data.setIsArchivedThirdPartyClicked(true);
                                data.setIsAddThirdPartyClicked(false);
                            });
                        } else {
                            data.setIsArchivedThirdPartyClicked(true);
                            data.setIsAddThirdPartyClicked(false);
                        }
                    }}
                >
                    {t("Archived third parties")} ({numberArchived})
                </div>
                <div
                    style={{ cursor: "pointer" }}
                    className={`${classnames(
                        "dropdown-item pl-1  cmn_btn_FRhistory",
                        {
                            "not-allowed-icon__clz":
                                data.selectedRows.length === 0 || isLoading,
                        }
                    )}`}
                    onClick={() => {
                        if (isEdited === true) {
                            setIsActionsClicked(!isActionsClicked);
                            setActions(() => {
                                setIsEdited(false);
                                data.setIsAddThirdPartyClicked(false);
                                if (data.selectedRows.length === 1) {
                                    ErrorToast(
                                        `${t(
                                            "Attention, it is a multiple action. Please select at least two items"
                                        )!}`
                                    );
                                } else
                                    setIsHistoryModalOpened(
                                        !isHistoryModalOpened
                                    );
                            });
                        } else {
                            if (data.selectedRows.length === 1) {
                                ErrorToast(
                                    `${t(
                                        "Attention, it is a multiple action. Please select at least two items"
                                    )!}`
                                );
                            } else
                                setIsHistoryModalOpened(!isHistoryModalOpened);
                        }
                    }}
                >
                    {t("Historical")}
                </div>
                {modify === true ? (
                    <>
                        <div
                            style={{ cursor: "pointer" }}
                            className={`${classnames(
                                "dropdown-item pl-1 cmn_btn_FRarchived cmn_btn_FRunarchive",
                                {
                                    "not-allowed-icon__clz":
                                        isLoading ||
                                        data.selectedRows.length === 0 ||
                                        (data.isArchivedThirdPartyClicked &&
                                            oneShop &&
                                            data.selectedRows.some(
                                                (element: any) =>
                                                    dataArchive.includes(
                                                        element.Id
                                                    )
                                            )),
                                }
                            )}`}
                            onClick={() => {
                                if (isEdited === true) {
                                    setIsLoading(false);
                                    setIsActionsClicked(!isActionsClicked);
                                    setActions(() => {
                                        setIsEdited(false);
                                        data.setIsAddThirdPartyClicked(false);
                                        if (data.selectedRows.length === 1) {
                                            ErrorToast(
                                                `${t(
                                                    "Attention, it is a multiple action. Please select at least two items"
                                                )!}`
                                            );
                                        } else if (
                                            !data.isArchivedThirdPartyClicked
                                        ) {
                                            thirdPartyExistInShops();
                                            setIsActive(true);
                                        } else {
                                            thirdPartyExistInShopsActivated();
                                            setIsActive(false);
                                        }
                                    });
                                } else {
                                    if (data.selectedRows.length === 1) {
                                        ErrorToast(
                                            `${t(
                                                "Attention, it is a multiple action. Please select at least two items"
                                            )!}`
                                        );
                                    } else if (
                                        !data.isArchivedThirdPartyClicked
                                    ) {
                                        thirdPartyExistInShops();
                                        setIsActive(true);
                                    } else {
                                        thirdPartyExistInShopsActivated();
                                        setIsActive(false);
                                    }
                                }
                            }}
                        >
                            {data.isArchivedThirdPartyClicked
                                ? t("Unarchive")
                                : t("Archive")}
                        </div>
                    </>
                ) : null}
            </div>
            {isArchivedValidationModalOpened ? (
                <ConfirmationArchive
                    data={{
                        isArchiveSVModalOpened: isArchivedValidationModalOpened,
                        setIsArchiveSVModalOpened: setIsArchivedValidationModalOpened,
                        setIsValidateClicked,
                    }}
                />
            ) : null}
        </div>
    );
}
